<section
  class="pp-form pp-revamp"
  [class.pp-form--dialog]="dialog">
  <header class="pp-form__header" *ngIf="showHeader && (title || subtitle || backLink?.length)">
    <a
      *ngIf="backLink?.length && !dialog"
      class="pp-btn"
      [routerLink]="backLink">
      <i class="pi pi-arrow-left"></i> Back
    </a>
    <div class="pp-form__titles">
      <h1 *ngIf="title">{{ title }}</h1>
      <p *ngIf="subtitle" class="pp-sub">{{ subtitle }}</p>
    </div>
    <div class="pp-form__header-actions">
      <ng-content select="[headerActions]"></ng-content>
    </div>
  </header>

  <ng-content></ng-content>

  <div class="pp-sticky-save" *ngIf="showFooter" [class.pp-sticky-save--dialog]="dialog">
    <ng-content select="[footer]"></ng-content>
  </div>
</section>
